"use client";

import React from "react";
import { PageShell } from "@/components/templates/PageShell";
import { LegalDocTemplate } from "@/components/templates/LegalDocTemplate";

export default function PrivacyPolicyPage() {
  return (
    <PageShell>
      {() => (
        <LegalDocTemplate
          breadcrumbs={[
            { label: "Политика конфиденциальности" },
          ]}
          title="Политика в отношении обработки персональных данных"
          subtitle="Настоящая Политика определяет порядок обработки и меры по обеспечению безопасности персональных данных пользователей сайта компании «Альянс-Дизайн» в соответствии с Федеральным законом РФ № 152-ФЗ."
          effectiveDate="10 января 2026 г."
          version="3.2"
          companyDetails={{
            legalName: "ООО «Альянс-Дизайн»",
            inn: "1101123456",
            ogrn: "1141101007890",
            address: "167000, Республика Коми, г. Сыктывкар, ул. Первомайская, д. 62",
            email: "info@alyans-design.ru",
            phone: "8 (800) 123-45-67",
          }}
          sections={[
            {
              number: "1.0",
              title: "Общие положения",
              paragraphs: [
                "1.1. Настоящая Политика конфиденциальности действует в отношении всей информации, которую ООО «Альянс-Дизайн» (далее — Оператор) может получить о Пользователе во время использования официального сайта, сервисов онлайн-расчёта и форм обратной связи.",
                "1.2. Использование сервисов сайта означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки его персональных данных.",
                "1.3. В случае несогласия с этими условиями Пользователь должен воздержаться от предоставления своих персональных данных через формы на сайте.",
              ],
            },
            {
              number: "2.0",
              title: "Категории обрабатываемых данных",
              paragraphs: [
                "2.1. Оператор обрабатывает персональные данные, предоставляемые Пользователем добровольно при заполнении контактных форм: фамилия, имя, номер контактного телефона, адрес электронной почты, наименование представляемой организации.",
                "2.2. На сайте осуществляется сбор обезличенных данных о посетителях с помощью сервисов веб-аналитики (Яндекс.Метрика) с целью анализа посещаемости, улучшения юзабилити и оптимизации скорости загрузки страниц.",
              ],
            },
            {
              number: "3.0",
              title: "Цели сбора и обработки данных",
              paragraphs: [
                "3.1. Идентификация стороны в рамках взаимодействия, формирование индивидуальных коммерческих предложений и расчёт смет на производство полиграфической и рекламной продукции.",
                "3.2. Установление с Пользователем обратной связи, включая направление уведомлений, звонков дежурных технологов, запросов касательно согласования макетов и условий доставки.",
                "3.3. Заключение, исполнение и контроль выполнения договоров поставки и подряда на изготовление рекламных конструкций.",
              ],
            },
            {
              number: "4.0",
              title: "Порядок хранения и передачи третьим лицам",
              paragraphs: [
                "4.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные правовые, организационные и технические меры, исключающие доступ неуполномоченных лиц.",
                "4.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства РФ (по мотивированному запросу судебных или правоохранительных органов).",
                "4.3. Базы данных информации граждан Российской Федерации размещены исключительно на серверах, физически расположенных на территории Российской Федерации.",
              ],
            },
            {
              number: "5.0",
              title: "Права пользователя и актуализация данных",
              paragraphs: [
                "5.1. Пользователь имеет право на получение информации, касающейся обработки его персональных данных, а также право требовать их уточнения, блокирования или уничтожения.",
                "5.2. Согласие на обработку персональных данных может быть отозвано Пользователем в любой момент путём направления письменного уведомления Оператору по электронной почте info@alyans-design.ru с пометкой «Отзыв согласия на обработку персональных данных».",
              ],
            },
          ]}
        />
      )}
    </PageShell>
  );
}

